import { Component, OnDestroy, OnInit, Output, EventEmitter } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { Store } from "@ngrx/store";
import { ToastrService } from "ngx-toastr";
import { IPageChangeEvent } from "src/app/components/pagination/pagination.component";
import { ViewApplication } from "src/app/models/applications";
import { ApplicationService } from "src/app/shared/services/application.service";
import { SessionStorageService } from "src/app/shared/services/session-storage.service";
import { UserSessionService } from "src/app/shared/services/user.session.service";
import { IAppState } from "src/app/store/index.state";
import { environment } from "src/environments/environment";
import { FormControl } from "@angular/forms"; 
import { searchApplication } from "src/app/shared/models/application";

import {
  deleteApplication,
  deleteApplicationTemplate,
  loadApplications,
  loadApplicationTemplates,
  setPageNumber,
  setPageSize
} from "./store/application.actions";
import {
  getApplications,
  getApplicationTemplates,
  getPageNumber,
  getPageSize,
  getTotal
} from "./store/application.selectors";

@Component({
  selector: "app-application",
  templateUrl: "./application.component.html",
  styleUrls: ["./application.component.scss"],
})
export class ApplicationComponent implements OnInit, OnDestroy {
  selectedApplication!: any;
  selectedApplicationIdentifier!: string;
  selectedModuleName: string = '';
  validModuleNames: string[] = ['iot', 'robotics', 'data_science', 'aiot', 'artificial_intelligence', "iiot", "aiot_v2"];
  isEdit = !!this.selectedApplication;
  isMenuOpen: boolean = false;
  isModalOpen: boolean = false;
  isDialogOpen: boolean = false;
  isFromGCC: boolean = false;
  maxDate: string;
  currentDate: string;
  dateControl = new FormControl("");
  isAdmin: boolean = window.location.href.includes('/admin/application') || window.location.href.includes('/admin/template');
  templateFlag: boolean = true;
  userAppFlag: boolean = false;
  searchControl = new FormControl("");
  clearDropDown = new FormControl("");
  currentUser: string;
  ApplicationType: string = null;
  dropdownOptions: string[] = ['GROK', 'SCHOOL', 'COLLEGE', 'INDUSTRY'];
  dropdownStatus: string[] = ['Internally', 'Externally', 'Unpublished'];
  dropdownUserSolutionStatus: string[] = ['Published', 'UnPublished'];
  status: string;
  orgId: string;
  userPermissions: string[];
  list: any;
  moduleName: string;
  isLmsLogin: boolean = false;

  isTemplate: boolean = false;
  shareItem: ViewApplication | null = null;
  currentItem: any;
  applicationidentifier: any;
  modalType: string = "";
  isLoading: boolean = false;


  isUserTemplate: boolean = false;
  filteredApplications: ViewApplication[] = [];
  readonly domainUrl: string = environment.domainUrl;

  currentPage = 1;
  pageSize = 100;
  totalRecords = 0;
  totalPages = 0;

  applications$ = this.store.select(getApplications);
  applicationTemplates$ = this.store.select(getApplicationTemplates);
  total$ = this.store.select(getTotal);
  pageNumber$ = this.store.select(getPageNumber);
  pageSize$ = this.store.select(getPageSize);


  @Output() editApplication = new EventEmitter();

  constructor(
    private store: Store<IAppState>,
    private router: Router,
    private route: ActivatedRoute,
    private applicationService: ApplicationService,
    private sessionStorageService: SessionStorageService,
    private toasterService: ToastrService,
    private userSessionService: UserSessionService,
  ) { }

  async ngOnInit() {
    this.currentUser = this.sessionStorageService.getUsername();
    this.userPermissions = sessionStorage.getItem('userPermissions') ? sessionStorage.getItem('userPermissions').split(",") : [];
    this.orgId = sessionStorage.getItem("organization_name") ? sessionStorage.getItem("organization_name") : this.sessionStorageService.getCurrentOrganization();
    this.fetchCurrentModule();
    if(sessionStorage.getItem('isGCCLogin') === 'true'){
      this.isFromGCC = true;
      this.userApplication(false);
    } else{
      if(this.userPermissions.includes('view_apptemplate')){
        this.template(false);
      }else if(this.userPermissions.includes('view_app')){
      this.userApplication(false);
      }
    }
    this.isLoading = true;
    await this.userSessionService.extendToken(this.sessionStorageService.getUsername()).toPromise();
    this.isLoading = false;
    const date = new Date();
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    this.maxDate = `${year}-${month}`;
    sessionStorage.removeItem("app_id");
  }

  fetchCurrentModule() {
    this.route?.queryParams?.subscribe((data: any) => {
      if (data['moduleName']) {
        const moduleName = data['moduleName'];
        if (this.validModuleNames.includes(moduleName)) {
          this.selectedModuleName = moduleName;
          this.moduleName = moduleName;
        } 
        console.log({ moduleName });
      } 
    });
  }

  handleDatePicker(event: Event) {
    const dateFilter = ((event.target as HTMLInputElement).value)
    this.sortfilterColumn(this.searchControl.value, this.moduleName, dateFilter);
  }
 
  applyFilter(event: Event) {
    const filterValue = ((event.target as HTMLInputElement).value).toLowerCase();
    this.sortfilterColumn(filterValue, this.moduleName)
  }

  onChangeOrgType(event: any) {
    if (event.target.value != "") {
      this.ApplicationType = event.target.value;
    } else {
      this.ApplicationType = null;
    }
    this.sortfilterColumn();
  }

  onChangeStatus(event: any) {
    if (event.target.value === "Internally") {
      this.status = "Internally";
    }
    else if (event.target.value === "Externally") {
      this.status = "Externally";
    }
    else if (event.target.value === "Unpublished") {
      this.status = "Unpublished"
    }
    else if (event.target.value === "Published") {
      this.status = "Publish"
    }
    else if (event.target.value === "UnPublished") {
      this.status = "UnPublish"
    }
    else if (event.target.value === "") {
      this.status = null;
    }
    this.sortfilterColumn();
  }

  async sortfilterColumn( value?: any, moduleName?: string, dateFilter?: any) { moduleName = moduleName ?? this.moduleName;
    this.currentPage = 1;
    if (this.isTemplate) {
      this.isLoading = true;
      const getApplication: any = {} as searchApplication;
      getApplication.userName = this.currentUser;
      getApplication.applicationType = this.ApplicationType ? this.ApplicationType : null;
      getApplication.organizationId = this.orgId;
      getApplication.status = this.status;
      getApplication.moduleName = moduleName;
      getApplication.searchString = value ? value : this.searchControl.value;
      getApplication.createdDate = dateFilter ? dateFilter : this.dateControl.value;
      getApplication.page = this.currentPage;
      getApplication.pageSize = this.pageSize;
      this.applicationService.getAllApplicationTempRender(getApplication).subscribe((response: any) => {
        this.list = response.applications;
        this.filteredApplications = this.list;
        this.totalRecords = response.totalRecords || this.filteredApplications.length;
        this.totalPages = response.totalPages || 1;
        this.isLoading = false;
      },
        (error: any) => {
          this.isLoading = false;
          if (error.status == 403) {
            // showForbiddenError(this.toasterService);
          }
        }
      )
    }
    else {
      this.isLoading = true;
      const getApplication: any = {} as searchApplication;
      getApplication.userName = this.currentUser;
      getApplication.applicationType = this.ApplicationType ? this.ApplicationType : null;
      getApplication.organizationId = this.orgId;
      getApplication.status = this.status;
      getApplication.moduleName = moduleName;
      getApplication.appUserId = this.isAdmin ? '*' : this.currentUser;
      if (!this.isAdmin) {
        getApplication.isLmsLogin = false;
      }
      getApplication.searchString = value ? value : this.searchControl.value;
      getApplication.createdDate = dateFilter ? dateFilter : this.dateControl.value;
      getApplication.page = this.currentPage;
      getApplication.pageSize = this.pageSize;
      this.list = await this.applicationService.getAllSearchApplication(getApplication).toPromise();
      if (this.list.success) {
        this.filteredApplications = this.filterApplicationByModuleName(this.list.applications);
        this.totalRecords = this.list.totalRecords || this.filteredApplications.length;
        this.totalPages = this.list.totalPages || 1;
        this.isLoading = false;
      }
    }
  }

  goToPage(page: number) {
    if (page < 1 || page > this.totalPages || page === this.currentPage) return;
    this.currentPage = page;
    if (this.isTemplate) {
      this.template(true);
    } else {
      this.userApplication(true);
    }
  }

  getPaginationRange(): string {
    const start = (this.currentPage - 1) * this.pageSize + 1;
    const end = Math.min(this.currentPage * this.pageSize, this.totalRecords);
    return start + ' – ' + end + ' of ' + this.totalRecords;
  }

  fetchApplications() {
    if (!this.isAdmin) {
      this.store.dispatch(loadApplications());
      this.applications$.subscribe((applications: ViewApplication[]) => {
        this.filteredApplications = applications;
      });
    } else {
      this.store.dispatch(loadApplicationTemplates());
      this.applicationTemplates$.subscribe((applications: ViewApplication[]) => {
        this.filteredApplications = applications;
      })
    }
    this.applications$.subscribe((applications: ViewApplication[]) => {
      this.filteredApplications = applications;
    });
  }

  async openApplication(item: ViewApplication) {
    const { applicationIdentifier } = item;
    if ((this.isTemplate && this.userPermissions.includes('edit_apptemplate')) || 
    (!this.isTemplate && this.userAppFlag && this.userPermissions.includes('edit_app'))) {
        if (applicationIdentifier) {
            sessionStorage.setItem('appId', applicationIdentifier);
            this.navigateToUrlFrom("edit/" + applicationIdentifier, true);
        }
    }
  }

  navigatetocircuit(app_id : any){
    sessionStorage.setItem("appid" , app_id )
    this.navigateToUrlFrom('circuit');
  }

  navigateToReference(appId: string, appType:string, route: string) {
    sessionStorage.setItem('app_id', appId);
    sessionStorage.setItem('app_type', appType);
    let url: string = ""
      if(this.isAdmin){
        url = `admin/${appType}/${route}`;
      } else {
        url = `ide/${appType}/${route}`;
      }
    this.router.navigateByUrl(url);
  }
  
  navigateToUrlFrom(route: string, isEdit?: boolean, isFromApplication?: boolean) {
    let url: string = ""
    if (isEdit && isFromApplication) {
      url = `admin/template/${route}`;
    }
    else if (isEdit && !isFromApplication && !this.isAdmin) {
      url = `ide/application/${route}`;
    }
    else if (isEdit) {
      if (this.isAdmin && this.templateFlag) {
        url = `admin/template/${route}`;

      } else if (this.isAdmin && this.userAppFlag) {
        url = `admin/application/${route}`;

      } else if (!this.isAdmin && this.userAppFlag) {
        url = `ide/application/${route}`;
      }
    }
    else {
      if (this.isAdmin && this.templateFlag) {
        url = `admin/template/${route}`;
      } else if (this.isAdmin && this.userAppFlag) {
        url = `admin/application/${route}`;
      }
    }
    this.router.navigateByUrl(url);
  }

  ngOnDestroy() { }

  onPageChange(event: IPageChangeEvent) {
    if (event) {
      this.store.dispatch(setPageNumber({ value: event.page }));
    }
  }

  onPageSizeChange(event: any) {
    if (event) {
      this.store.dispatch(setPageSize({ value: event }));
    }
  }

  removeApplication(id?: string) {
    if (this.templateFlag) {
      // this.store.dispatch(deleteApplicationTemplate({ id }));
      this.template(true);
    } else {
      // this.store.dispatch(deleteApplication({ id }));
      this.userApplication(true);
    }
  }

  async publishModal(CurrentItem: ViewApplication) {
    console.log("one");
    if ((this.isTemplate && this.userPermissions.includes('publish_app_template')) || 
    (!this.isTemplate && this.userAppFlag && this.userPermissions.includes('edit_app'))) {
        if (this.templateFlag) {
          console.log("isTemplate:::::::If");
          
            this.shareItem = CurrentItem;
            this.currentItem = CurrentItem.applicationType;
            this.applicationidentifier = CurrentItem.applicationIdentifier;
            this.isModalOpen = true;
            this.modalType = "publish_unpublish";
        } else {
          console.log("Else");
            const payload = {
                updatedBy: this.sessionStorageService.getUsername()
            };
            try {
                const result = await this.applicationService.publishUnPublishApplication(payload, CurrentItem.applicationIdentifier).toPromise();
                if (result) {
                    this.toasterService.success(result.message);
                    this.userApplication(true);
                }
            } catch (err: any) {
                this.toasterService.error(`${err.error.message}`);
            }
        }
    } 
}

  // changePublishedFlag(currentItem: ViewApplication): void {
  //   let flag = currentItem.is_published;
  //   let appId = currentItem.applicationIdentifier;
  //   let payload = {
  //     "is_published": !flag
  //   }
  //   this.applicationService.updateApplicationTemp(payload, appId)
  //     .toPromise()
  //     .then(result => {
  //       this.fetchApplications();
  //     });
  // }

  // changePublishedFlag(currentItem: ViewApplication): void {
  //   let appId = currentItem.applicationIdentifier;
  //   let payload = {
  //     "is_published": false,
  //     "isInternallyPublished": false
  //   }

  //   this.applicationService.updateApplicationTemp(payload, appId)
  //     .toPromise()
  //     .then(result => {
  //       this.fetchApplications();
  //     });
  // }

  // openPublish(item:ViewApplication): void{
  //   this.selectedApplication = item;
  //   console.log(this.selectedApplication);
    
  //   this.selectedApplicationIdentifier = item.applicationIdentifier
  //   this.isDialogOpen = true;
  //   console.log(this.isDialogOpen);
  // }

  // closeDialog(event:any): void {
  //   this.isDialogOpen = false
  //   // this.selectedApplication = null
  // }

  confirmAndDelete(item: ViewApplication): void {
    this.selectedApplication = item;
    this.selectedApplicationIdentifier = item.applicationIdentifier;
    this.isModalOpen = true;
    this.modalType = "delete";
  }

  async clone(item: ViewApplication) {
    this.selectedApplication = item;
    let id = this.selectedApplicationIdentifier = item.applicationIdentifier;
    try {
      let result: any;
      const username = this.sessionStorageService.getUsername()
      // const username = JSON.parse(sessionStorage.getItem("user") || "{}")['name'];
      const payload = {
        reference_application_identifier: id,
        app_user_id: username
      }
      if (this.templateFlag) {
        result = await this.applicationService.cloneApplicationTemplate(payload).toPromise();
      } else if (this.userAppFlag) {
        result = await this.applicationService.cloneApplication(payload).toPromise();
      }

      if (result) {
        window.location.reload();
      }
    } catch (error) {
      console.log(error);
    }
  }

  async delete(event: any) {
    if (!event) {
      return;
    }
    const id: string = this.selectedApplicationIdentifier;
    try {
      let result: any;
      if (this.templateFlag) {
        result = await this.applicationService.deleteApplicationTemp(id).toPromise();
      } else {
        result = await this.applicationService.deleteApplication(id).toPromise();
      }
      if (result) {
        this.removeApplication(id);
      }
    } catch (error: any) {
      console.log(error);
      if (error.status == "200") this.removeApplication(id);
    } finally {
      this.isModalOpen = false;
    }
  }

  toggleMenu(): void {
    this.isMenuOpen = !this.isMenuOpen;
  }

  closeModal(event: any): void {
    this.selectedApplication = null;
    this.isModalOpen = false;
    this.removeApplication();
  }

  refresh(){
    if(this.templateFlag){
      this.template(false);
    }else if(this.userAppFlag){
      this.userApplication(false);
    }
  }

  onSelectModule(moduleName: string): void {
    // debugger;
    // let list;
    // if (this.templateFlag) {
    //   list = this.applicationTemplates$
    // } else {
    //   list = this.applications$;
    // }
    // list.subscribe((applications: any) => {
    //   if (moduleName === "all") {
    //     this.filteredApplications = applications;
    //   } else {
    //     console.log(applications);
    //     this.filteredApplications = applications.filter((data: any) => data.moduleName === moduleName);
    //   }
    // });
    this.moduleName = moduleName;
    this.sortfilterColumn(this.searchControl.value, moduleName);
    this.toggleMenu();
  }


  async template(tabValue: boolean) {
    this.templateFlag = true;
    this.userAppFlag = false;
    this.isTemplate = true;
    this.isLoading = true;
    if(!tabValue){
    this.searchControl.setValue('');
    this.clearDropDown.setValue('');
    this.ApplicationType = null;
    this.status = null;
    this.dateControl.setValue("");
    }
    // if (this.isAdmin) {
    //   this.fetchApplications();
    // }
    // else {
    //   //this.isUserTemplate=true;
    //   this.store.dispatch(loadApplicationTemplates());
    //   this.applicationTemplates$.subscribe((applications: any) => {
    //     const publishedApp = applications.filter((app: any) => {
    //       if (app.is_published) {
    //         return app
    //       }
    //     })
    //     this.filteredApplications = this.filterApplicationByModuleName(publishedApp);
    //   });
    //   this.applications$.subscribe((applications: any) => {
    //     this.filteredApplications = this.filterApplicationByModuleName(applications);
    //   });
    // }
    try {
      let tempdata: any;
      if (this.userPermissions.includes("view_apptemplate")) {
        const payload = {
          userName: this.currentUser,
          organizationId : sessionStorage.getItem("organization_name") ? sessionStorage.getItem("organization_name") : this.sessionStorageService.getCurrentOrganization(),
          applicationType : this.ApplicationType ? this.ApplicationType : null,
          status : this.status,
          moduleName : this.moduleName,
          searchString : this.searchControl.value,
          createdDate: this.dateControl.value,
          isLMSLogin: this.isAdmin ? false : true,
          page: this.currentPage,
          pageSize: this.pageSize
        }
        tempdata = await this.applicationService.getAllApplicationTempRender(payload).toPromise();
        if (tempdata.success) {
          this.filteredApplications = this.filterApplicationByModuleName(tempdata?.applications);
          this.totalRecords = tempdata.totalRecords || this.filteredApplications.length;
          this.totalPages = tempdata.totalPages || 1;
        } else {
          this.filteredApplications = [];
          this.isLoading = false;
      }
  }else {
      this.filteredApplications = [];
      this.toasterService.error('You don’t have permission to perform this action');
    }
    } catch (e: any) {
      this.isLoading = false;
      this.filteredApplications = [];
    }
    this.isLoading = false;

  }

  async userApplication(tabValue: boolean) {
    this.templateFlag = false;
    if(!tabValue) {
      this.searchControl.setValue('');
      this.clearDropDown.setValue('');
      this.status = null;
      this.dateControl.setValue("");
      this.currentPage = 1;
    }
    this.userAppFlag = true;
    this.isTemplate = false;
    this.filteredApplications = []
    let data: any;
    const username = this.sessionStorageService.getUsername();
    if(this.userPermissions.includes("view_app") || this.isFromGCC){
         try {
    if (this.isAdmin) {
      this.isLoading = true;
      data = await this.applicationService
        .getAllApplication(sessionStorage.getItem("organization_name"), "*", this.moduleName || "", username, this.status, this.searchControl.value, this.dateControl.value, this.isFromGCC, undefined, undefined, this.currentPage, this.pageSize)
        .toPromise();
    } else {
      data = await this.applicationService
        .getAllApplication(sessionStorage.getItem("organization_name"), "*", this.moduleName || "", username, this.status, this.searchControl.value, this.dateControl.value, this.isFromGCC, undefined, undefined, this.currentPage, this.pageSize)
        .toPromise();
    }
    if (data) {
      this.filteredApplications = this.filterApplicationByModuleName(data?.applications);
      if (this.isFromGCC) {
        this.filteredApplications = this.filteredApplications.filter(item => item.createdBy == (sessionStorage.getItem('student')));
      }
      this.totalRecords = data.totalRecords || this.filteredApplications.length;
      this.totalPages = data.totalPages || 1;
    }
  } catch (e: any) {
    if(e.status == 403){
      this.toasterService.error('You don’t have permission to perform this action');
    }
    this.isLoading = false;
    this.filteredApplications = [];
  }
  }else{
    this.toasterService.error('You don’t have permission to perform this action');
  }
    this.isLoading = false;
    this.store.dispatch(loadApplications());
  }

  filterApplicationByModuleName(applications: any[]) {
    let filteredApplications = applications;
    if (this.selectedModuleName.length > 0) {
      filteredApplications = applications.filter(app => app.moduleName.toLowerCase() == this.selectedModuleName.toLowerCase());
    }
    return filteredApplications;
  }

  async saveAsTemplate(item: any) {
    try {
      let result: any;
      const username = this.sessionStorageService.getUsername();
      let payload: any = {
        applicationName: item.applicationName || "",
        applicationDesc: item.applicationDesc || "",
        boardIdentifier: environment.boardIdentifier,
        organizationID: this.sessionStorageService.getCurrentOrganization(),
        moduleName: item.moduleName,
        controller_type: '',
        simulator_type: '',
        appUserID: username || "Anonymous",
        createdBy: username || "Anonymous",
        updatedBy: username || "Anonymous",
        referenceApplicationIdentifier: item.applicationIdentifier,
        operationType: "Copy"
      };
      payload = { ...payload };
      if (this.isAdmin) {
        result = await this.applicationService
          .createApplicationTemp(payload)
          .toPromise();
      }
      if (result) {
        this.toasterService.success("Application saved as template");
        this.navigateToUrlFrom("edit/" + result.applicationIdentifier, true, true)
      }
    } catch (error) {
      console.log(error);
    }

  }

  async saveAsApplication(item: any) {
    const username = this.sessionStorageService.getUsername();
    let payload: any = {
      applicationName: item.applicationName || "",
      applicationDesc: item.applicationDesc || "",
      boardIdentifier: environment.boardIdentifier,
      organizationID: this.sessionStorageService.getCurrentOrganization(),
      moduleName: item.moduleName,
      controller_type: item.controller_type || '',
      simulator_type: item.simulator_type || '',
      appUserID: username || "Anonymous",
      createdBy: username || "Anonymous",
      updatedBy: username || "Anonymous",
      problemTryingToSolve: item.problemTryingToSolve || "",
      industryDesignedFor: item.industryDesignedFor?.industry_name || "",
      applicationCreationProcedure: item.applicationCreationProcedure || "",
      referenceApplicationIdentifier: item.applicationIdentifier,
      operationType: "Copy"
    };
    payload = { ...payload };
    let result: any = await this.applicationService
      .createApplication(payload)
      .toPromise();
    if (result) {
      this.toasterService.success("Template saved as application");
      this.navigateToUrlFrom("edit/" + result.applicationIdentifier, true, false)
    }
  }

  backtoGCC() {
      sessionStorage.removeItem('ChallengeId');
      sessionStorage.removeItem('StudentId');
      sessionStorage.removeItem('Student');

      window.open(environment.gccDevFrontEndUrl, "_self");
  }
}